import onboardingBackground from '@/assets/images/onboarding/onboarding_background.png'
import onboardingUpdateProfileEn from '@/assets/images/onboarding/onboarding_update_profile_en.png'
import onboardingUpdateProfilePl from '@/assets/images/onboarding/onboarding_update_profile_pl.png'
import onboardingAddDeliveryRequest from '@/assets/images/onboarding/onboarding_add_delivery_request.png'
import onboardingDeliveryKeyEn from '@/assets/images/onboarding/onboarding_delivery_key_en.png'
import onboardingDeliveryKeyPl from '@/assets/images/onboarding/onboarding_delivery_key_pl.png'
import onboardingNotificationEn from '@/assets/images/onboarding/onboarding_notification_en.png'
import onboardingNotificationPl from '@/assets/images/onboarding/onboarding_notification_pl.png'
import onboardingCollectomate from '@/assets/images/onboarding/onboarding_collectomate.png'

import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import toastStore from '@/stores/toast-store.js'
import axios from 'axios'
import { Carousel, Slide } from 'vue-carousel'
import { EventBus } from '@/event-bus.js'

import VerifyPhoneModal from '@/vcs/_shared/modals/verify-phone-modal/cmp.vue'

export default {
  name: 'OnboardingScreen',
  mixins: [CurrentUserResolver],
  data: function () {
    return {
      showAgreeButton: false,
      onboardingBackground,
      onboardingUpdateProfileEn,
      onboardingUpdateProfilePl,
      onboardingAddDeliveryRequest,
      onboardingDeliveryKeyEn,
      onboardingDeliveryKeyPl,
      onboardingNotificationEn,
      onboardingNotificationPl,
      onboardingCollectomate,
      hasCollectomatesWithByUserDeliveryScenario: false,
      blocker: false,
    }
  },
  mounted() {
    this.fetchCollectomates()
  },
  methods: {
    skipOnboarding() {
      EventBus.$emit(`prefetchLockers`)
      this.isPhoneVerified() ? null : this.showVerifyPhoneNumberModal()
      this.$emit('hideOnboarding')
      localStorage.setItem('skip_onboarding', true)
    },

    pageChangeHandler(pageNumber) {
      if (pageNumber == 4 && this.hasCollectomatesWithByUserDeliveryScenario) {
        this.showAgreeButton = true
      } else if (pageNumber == 2 && !this.hasCollectomatesWithByUserDeliveryScenario) {
        this.showAgreeButton = true
      } else {
        this.showAgreeButton = false
      }
    },

    isPhoneVerified() {
      return !!this.currentUser && !!this.currentUser.phone && !!this.currentUser.phoneIsVerified
    },

    isAppInstalled() {
      // INFO: Only way to determine if app was previously installed is checking if there is empty `window.deferredPrompt`
      return !window.deferredPrompt
    },

    showVerifyPhoneNumberModal() {
      this.$store.commit('modal/open', {
        cmp: VerifyPhoneModal,
        animation: 'slide-down-menu',
        callback: this.checkIfPhoneVerifiedCallback,
      })
    },

    // showAddAppToHomeScreenModal() {
    //   this.$store.commit("modal/open", {
    //     cmp: ShowAddAppToHomeScreenModal,
    //     animation: "slide-down-menu"
    //   });
    // },

    // showiOSAddToHomeScreenPromptModal() {
    //   this.$store.commit("modal/open", {
    //     cmp: iOSAddToHomeScreenPromptModal,
    //     animation: "slide-down-menu"
    //   });
    // },

    checkIfPhoneVerifiedCallback() {
      this.$router.push('profile/phone/verification')
    },

    fetchCollectomates: function () {
      this.blocker = true
      axios({
        method: 'get',
        url: 'collection_points',
      })
        .then(response => {
          this.hasCollectomatesWithByUserDeliveryScenario =
            response.data.filter(cp => {
              return cp.deliveryScenarios[0] === 'by_user'
            }).length > 0
        })
        .catch(error => {
          const errorMessage = error.response.data.errors
            ? Object.values(error.response.data.errors).join(', ')
            : this.$t('messages.error')
          toastStore.commit('error', { message: errorMessage })
        })
        .finally(() => {
          this.blocker = false
        })
    },
  },
  components: {
    Carousel,
    Slide,
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
